<template>
  <div class="input-wrapper" :class="(inputValue !== '' && inputValue !== null) ? 'input--has--value' : ''">
    <label v-if="label" :for="id">{{label}}</label>
     <input
      v-model="inputValue"
      :id="id"
      :type="type"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      @click="$emit('click')"
      @input="$emit('input',$event.target.value)"
      :class="classes"
    />
    <span class="input--arrow">
      <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.191434 9.84396C-0.0475602 9.62106 -0.0651732 9.24159 0.152094 8.99639L3.69331 5L0.152095 1.00361C-0.0651731 0.758412 -0.0475601 0.378944 0.191434 0.15604C0.430429 -0.0668642 0.800303 -0.0487938 1.01757 0.196401L4.79721 4.46186C5.0676 4.767 5.0676 5.233 4.79721 5.53814L1.01757 9.8036C0.800303 10.0488 0.430429 10.0669 0.191434 9.84396Z" fill="#7A7A7A"/>
      </svg>
    </span>
  </div>
</template>

<script>

export default {
  name: 'Input',
  data: () => ({
    inputValue: null
  }),
  components: {
  },
  computed: {
  },
  props: {
    id: { type: [Number, String], required: false, default: null },
    type: { type: String, required: false, default: null },
    value: { type: [Number, String], required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    classes: { type: String, required: false, default: null },
    required: { type: String, required: false, default: null }
  },
  watch: {
    // Watch for state changes
    value: {
      handler (state) {
        this.inputValue = this.value
      },
      deep: true
    }
  },
  mounted () {
    this.inputValue = this.value
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../scss/global/includes";

.input-wrapper {
    width: 100%;
    max-width: 100%;
    display: block;
    position: relative;
    margin-bottom: 8px;

    &.input--has--value {
      .input--arrow svg  path {
        fill: $primary-grey;
      }
      input {
        color: $primary-grey;
        border: 1px solid $primary-grey;
        background: $blue-15-opacity;
      }
    }

}

.input-wrapper label {
    color: $primary-grey;
    font-size: 14px;
    padding-bottom: 8px;
    display: block;
}

.input-wrapper input {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    outline: none;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid $divider-dark;
    color: $primary-grey;
    border-radius: 2px;
    margin-bottom: 0px;
    padding: 16px 10px;
    display: block;
    width: 100%;
    outline: none;
    background: #FFFFFF;

    &:focus {
      // border: 1px solid $primary;
      // color: $primary;
    }

    @include placeholder {
      color: $primary-grey;
    }
}


.input-wrapper .input--arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0px, -50%);
}

</style>
